"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelProperties = {
    modelName: 'MediaGroup',
    tableName: 'MediaGroup',
    associations: [{
            type: 'hasMany',
            model: 'Media',
            parameters: { foreignKey: { name: 'mediagroup_id', fieldName: 'mediagroup_id' } },
            followFor: ['Archive', 'DocumentClone'],
            includeRestores: ['MediaGroup'],
        }, {
            type: 'belongsTo',
            model: 'DocumentItem',
            parameters: { as: 'DocumentItem', foreignKey: { name: 'id', fieldName: 'id' }, scope: { type: ['Media', 'Media-l', 'Media-m', 'Media-fp'] } },
            followFor: ['Archive'],
        }, {
            type: 'belongsTo',
            model: 'JobItem',
            cascadeDelete: false,
            parameters: { as: 'JobItem', foreignKey: { name: 'jobitem_id', fieldName: 'jobitem_id' } },
        }, {
            type: 'belongsTo',
            serverOnly: true,
            model: 'Job',
            parameters: { as: 'Job', foreignKey: { name: 'job_id', fieldName: 'job_id' } },
            followFor: ['ParentCheck'],
        }],
    validations: { title: { type: 'length', max: 60 } },
};
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/mediaGroup/modelProperties.js.map